import styled, { css } from "styled-components"
import Breakpoints from "../shared/breakpoints"
import {
  desktopTextStyles,
  mobileTextStyles,
  tabletTextStyles,
} from "../shared/typography.styles"

export const StatItem = styled.ul`
  display: flex;
  flex-direction: column;
`

export const StatItemNumber = styled.span`
  letter-spacing: 140%;
  ${mobileTextStyles.MobileHeadingTwoRegular}

  & > span {
    line-height: 0px;
  }

  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletHeadingThreeRegular}
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingThreeRegular}

    & > span {
      font-size: 18px;
    }
  }
`

export const StatItemDescription = styled.span`
  ${desktopTextStyles.LinkText}
  line-height: 140%;
  opacity: 0.5;
  letter-spacing: 0.05em;
`
export const CopyText = styled.p`
  ${desktopTextStyles.BodyText18}
  padding: 32px 0 48px 0;

  @media (min-width: ${Breakpoints.md}) {
    padding: 32px 0;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.BodyText18}
    padding: 32px 0 64px 0;
  }
`

export const LinkStyle = css`
  flex-grow: 1;
`

export const OutlineLinkStyle = css`
  ${LinkStyle}
  background: none;
  border: 1px solid var(--white);
`
